module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-43a79b8cbaaa291b72bcbcd1af687ec7.png";